import { useEffect, useState } from "react";
import { CheckSubscriptionStatus, GoogleSignIn } from "../../constants/api-urlConstants";
import instance from "../../utils/axiosInstance";
import { handleSaveUserInfo, isDocSearchOnlyUser, navigateToRespectiveApp, redirectToRespectiveAppByRoles } from "../../utils";
import { HelpPopup } from "../../components/helpPopup/helpPopup";
import Logo from "../../assets/images/infraclearlogo.png";
import EmbeddedCheckout from "../signUpTrial/embeddedCheckout";
import { ROLES } from "../../constants/commonConstants";
import { apiBasePath, googleAppRedirectUrl, googleAppUrl } from "../../constants/env-url";
import TrialStepper from "../signUpTrial/trialStepper";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { ErrorOutline } from "@mui/icons-material";

const LoginWithGoogle = () => {
	const param = new URLSearchParams(window.location.search);
  const code = param.get('code');
  const error = param.get('error');
  const access = param.get('access');
	const [userInfo, setUserInfo] = useState<any>();
	const [userExistingInfo, setUserExistingInfo] = useState<any>();
	const [stepperInfo, setStepper] = useState({ activeStep: 2 });
	const [googleVerificationStatus, setGoogleVerificationStatus] = useState<any>({ verifying: false, error: null });

	useEffect(() => {
		if (code) {
			verifyGoogleSignin().then(googleUserRes => {
				if (googleUserRes && googleUserRes?.email) {
					const api_url = `${apiBasePath}${CheckSubscriptionStatus}`;
					const payload = { email: googleUserRes?.email };
					instance.post(api_url, payload).then((res) => {
						setUserExistingInfo(res?.data?.data);
						if (res?.data?.data?.hasActiveSubscription || res?.data?.data?.subscriptionStatus != null) {
							redirectToRespectiveAppByRoles(googleUserRes?.roles || []);
							const isAdmin_value = googleUserRes?.roles && googleUserRes?.roles?.length > 0 && googleUserRes?.roles.includes("SUPER_ADMIN");
							const userInfo: any = {
								id: googleUserRes?.id,
								roles: googleUserRes?.roles,
								isAdmin: isAdmin_value
							}
							handleSaveUserInfo(userInfo);
							if (googleUserRes?.modules?.length === 1) {
								navigateToRespectiveApp(googleUserRes?.modules?.[0])
							} else if (googleUserRes?.modules?.length > 1) {
								if (!isDocSearchOnlyUser(googleUserRes?.roles || [])) {
									window.location.href = '/applications';
								}
							}
						} else {
							setStepper({ activeStep: 2 });
							setUserInfo(googleUserRes);
						}
					});
				}
			})
		}
	}, [code])

	useEffect(() => {
		if (error) {
			window.location.href = '/';
		}
	}, [error])

	const verifyGoogleSignin = () => {
		setGoogleVerificationStatus({ verifying: true, error: null });
    const url = `${GoogleSignIn}`;
    const payload = { code: code,role: access?.toLowerCase() === 'pro' ? 'pro' : 'basic' };
    return instance.post(url, payload).then((res) => {
      if (res?.data?.success) {
        return res?.data?.data;
      } else {
				setGoogleVerificationStatus((old: any) => ({ ...old, error: 'Something went wrong. Please try again.' }));
			}
    }).catch((e) => {
			setGoogleVerificationStatus((old: any) => ({ ...old, error: 'Something went wrong. Please try again.' }));
		}).finally(() => {
			setTimeout(() => {
				setGoogleVerificationStatus((old: any) => ({ ...old, verifying: false }));
			}, 1000);
		});
  }

	(window as any).dataPopupWebhookReceived = () => {
		setStepper({ activeStep: 3 });
    setTimeout(() => {
			tryAgain();
    }, 5000);
  };

	const tryAgain = () => {
		window.open(googleAppUrl + '&redirect_uri=' + googleAppRedirectUrl, '_self');
	}

  return (
		<div className="guest-signUp-wrapper flex-direction-column">
			<div className="pageHeader vertical-align">
				<img
					style={{ width: "220px", paddingLeft: "10px" }}
					alt="logo"
					src={Logo}
				/>
				<HelpPopup />
			</div>
			{(userInfo?.email && !userExistingInfo?.hasActiveSubscription) &&
			  (
					userInfo?.roles?.includes?.(ROLES.PRO_ACCESS_SUBSCRIBER) || userInfo?.roles?.includes?.(ROLES.BASIC_ACCESS_SUBSCRIBER)
				) &&
				<TrialStepper stepperInfo={stepperInfo} />
			}
			{googleVerificationStatus?.verifying &&
				<Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '70vh'}}>
					<Box>
						<Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2}}>
							<CircularProgress size={32} />
						</Box>
						<Box>
							<Typography variant="body1">Redirecting to the application...</Typography>
						</Box>
					</Box>
				</Box>
			}
			{googleVerificationStatus?.error &&
				<Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '70vh'}}>
					<Box>
						<Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2}}>
							<ErrorOutline color="error" sx={{ fontSize: 50 }} />
						</Box>
						<Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2}}>
							<Typography variant="body1">{googleVerificationStatus?.error}</Typography>
							<Button variant="contained" color="primary" onClick={tryAgain}>Try Again</Button>
						</Box>
					</Box>
				</Box>
			}
			{(userInfo?.email && !userExistingInfo?.hasActiveSubscription) &&
				<EmbeddedCheckout
					userData={userInfo}
					access={userInfo?.roles?.includes?.(ROLES.PRO_ACCESS_SUBSCRIBER) ? 'pro' : 'basic'}
				/>
			}

		</div>
	);
}

export default LoginWithGoogle;
